import { useState, useEffect } from 'react';
import useDataBean from '../../../../core/services/dataBean/useDataBean';
import useModal, { MODAL_md } from '../../../theme/Component/hooks/useModal';
import { Modal } from '../../../theme/Component/Modal';
import { BasicTable, MASK_NUMBER } from '../../../theme/Component/BasicTable';
import { _CommercialCampaign, _DistributionChannel, _SalesConsultant } from '../../../../core/services/dataBean/EntityCatalogVdos';
import usePaginator from '../../../theme/Component/usePaginator';
import { AccountantYear } from '../../../Talentohumano/GestionTH/EmployeeContract/ProductionPlan/AccountantYear';
import { MonthEditorbyconst } from '../../../RemoteAbstractAction/editors/MonthEditorbyconst';
import { BasicButton } from '../../../theme/Component/BasicButton';
import { _single } from '../../../../core/services/dataBean/EntityCatalog';
import { AccountEditor } from '../../../editor/AccountEditor';
import { SelectFunctionalID } from '../../../admin/configuracion/functionalID/SelectFunctionalID';


interface Props {
    idSelector: number;
    onChange: any;
    label?: string;
    returnType?: "ID" | "Object";
    render?: string;
}

export const SalesConsultantEditor = ({ idSelector, onChange, label, returnType = "ID", render }: Props) => {

    const { instance, lista, setLista } = useDataBean(_SalesConsultant)
    const [id, setID] = useState(null);
    const [Account, setAccount] = useState<number>(null)
    const [regexStr, setregexStr] = useState<any>(null)
    const [month, setMonth] = useState<any>(null);
    const [FunctionalID, setFunctionalID] = useState<number>(null)
    const [year, setYear] = useState<any>(_single.getCurrenYear());
    const modal = useModal("Consultores de Venta", MODAL_md);
    const paginador = usePaginator();
    useEffect(() => {
        setID(idSelector)
    }, [idSelector])


    const setValue = (e: string) => {
        const selectedId = parseInt(e);
        setID(selectedId);
        if (onChange) {
            const selectedItem = lista.find(
                (item) => item?.DataBeanProperties?.IDSalesConsultant == e
            );
            if (selectedItem) {
                onChange(returnType === "Object" ? selectedItem?.DataBeanProperties : selectedId);
            } else {
                onChange(returnType === "Object" ? {} : null);
            }
        }
    };

    useEffect(() => {
        getLista();
    }, [paginador.page])

    const getLista = () => {

        instance.getSalesConsultantCatalog(Account, FunctionalID, regexStr, paginador.page, 15).then(
            (resp: any) => {
                if (resp) {
                    paginador.setPages(resp.NumberOfPages);
                    paginador.setRecords(resp.NumberOfPages * (15));
                    paginador.setRegiPerPage(15)
                    // setLista(resp.List)
                    let x = resp.List;
                    x.forEach((user) => {
                        user.DataBeanProperties.Client = (user.DataBeanProperties.AccountNit ?? "") + "Sin Tercero" + (user.DataBeanProperties.AccountName ?? "");
                        user.DataBeanProperties.Group = (user.DataBeanProperties.FunctionalIDJsonCode ?? "") + "Sin Grupo" + (user.DataBeanProperties.FunctionalIDName ?? "");
                    });
                    setLista(x)

                }
            }
        )

    }
    const head = [
        { title: 'ID', property: 'IDSalesConsultant', visible: true },
        { title: 'Tercero', property: 'Client', visible: true },
        { title: 'Grupo Organizacional', property: 'Group', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
        { title: 'Desde', property: 'Since', visible: true },

    ]
    const abrirModal = () => {
        modal.open();
    }

    return (
        <>
            <label>{label ?? "Consultores de Venta"}</label>
            <span className='form-control cursor ifmodal' onClick={abrirModal}>{render ?? ''}</span>
            <Modal modal={modal.modal} updateModal={modal.setModal}>
                <div className="row">
                    <div className="col-md-6">
                        <AccountEditor label="Tercero" idAccount={Account} onChange={(e) => { setAccount(e.IDAccount) }}></AccountEditor>
                    </div>
                    <div className="col-md-6">
                        <SelectFunctionalID label='Grupo Organizacional' functionalIDLn={FunctionalID} onChange={(e) => { setFunctionalID(e.IDLn) }} />
                    </div>
                    <div className="col-md-6">
                        <label>Búsqueda por Texto</label>
                        <input type="text" className="form-control" value={regexStr} onChange={(e) => { setregexStr(e.target.value) }} />
                    </div>
                    <div className="col-md-6 mt-4 p-2">
                        <BasicButton icon="ri-align-justify" eventClick={getLista}>Buscar</BasicButton>
                    </div>
                    <div className="col-md-12">
                        <BasicTable head={head} body={lista} rowSet={(e) => { setValue(e.IDSalesConsultant); modal.close(); }} pageTop={paginador.page} next={paginador.next} back={paginador.back} records={paginador} customRows={15}></BasicTable>
                    </div>
                </div>

            </Modal>
        </>
    )
}